import { ApiService } from './ApiService';

import { ICourse } from '@/shared/ICourse';
import { StorageCacheService } from './StorageCacheService';
import { IUserInfo } from '@/shared/IUserInfo';
import { trimString } from '@/shared/parse';

export class CourseStorageService {

  static async getCourse(id: string, force?: boolean): Promise<ICourse | undefined> {

    const cached = StorageCacheService.getValue<ICourse>(`course/${id}`);
    if (!force && cached) {
      return cached;
    }

    const result = await ApiService.fetch<ICourse>(`/api/course/${id}`);
    if (result) {
      StorageCacheService.resetCache(`course/${id}`);
      StorageCacheService.setValue(`course/${id}`, result);
      return result;
    }
  }

  public static async getCourses(force?: boolean): Promise<{ courses: ICourse[], roles: string[] }> {
    if (!force) {
      const result = StorageCacheService.getValue<{ courses: ICourse[], roles: string[] }>('courses');
      if (result) {
        return result;
      }
    }

    const data = await ApiService.fetch<{ courses: ICourse[], roles: string[] }>('/api/course');

    StorageCacheService.resetCache('courses');
    StorageCacheService.setValue('courses', data);
    for (const course of data.courses) {
      StorageCacheService.setValue(`course/${course.id}`, course);
    }
    return data;
  }

  public static async patchCourse(courseId: string, course: Partial<ICourse>): Promise<ICourse> {
    const result: ICourse = await ApiService.fetch(`/api/course/${courseId}`, 'PATCH', course);
    StorageCacheService.resetCache('courses');
    StorageCacheService.setValue(`course/${courseId}`, result);
    return result;
  }

  public static async createCourse(course: Partial<ICourse>): Promise<ICourse> {
    const result: ICourse = await ApiService.fetch('/api/course', 'POST', <ICourse>{
      ...course,
      CourseTitle: trimString(course.CourseTitle),
      CourseIdentifier: trimString(course.CourseIdentifier),
    });
    StorageCacheService.resetCache('courses');
    StorageCacheService.setValue(`course/${result.id}`, result);
    return result;
  }

  static async deleteCourse(id: string) {
    await ApiService.fetch(`/api/course/${id}`, 'DELETE');
    StorageCacheService.resetCache('courses');
  }

  static async assignToExpert(courseId: string, expertId: string) {
    const result: ICourse = await ApiService.fetch(`/api/course/${courseId}/assignToExpert`, 'POST', { expertId });
    StorageCacheService.resetCache('courses');
    StorageCacheService.setValue(`course/${result.id}`, result);
    return result;
  }
  public static async remindProvider(courseId: string, userToNotify?: IUserInfo, message?: string): Promise<ICourse> {
    const reuslt = await ApiService.fetch<ICourse>(`/api/course/${courseId}/remind`, 'POST', { userToNotify, message });
    StorageCacheService.resetCache('courses');
    return reuslt;
  }
}
